export default __webpack_public_path__ + "static/media/JhonathanAntonio-img-xl.d6868789.png";